
<div class="app-container app-theme-white body-tabs-shadow">
    <div class="app-container">
    <div class="h-100">
    <div class="h-100 no-gutters row">
    <div class="h-100 d-flex bg-white justify-content-center align-items-center col-12">
    <div class="mx-auto app-login-box col-12 text-center">
    <div class="app-logo"></div>
     <h4 class="mb-">
    <div class="mb-3 h1 fw-bold">Page non trouvée </div>
    <span>La page à laquelle vous essayez d'accéder n'existe pas !</span>
    </h4>

    <h6 class="mb-0">
        <a routerLink="/" class="text-primary">Retourner</a>
        </h6>
   
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>
    